import React from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { parseSlug } from '../archives-utils/archivesUtils';
import play from '../../../assets/icons/play-54-4b7fa8b71484507993b8958a4124dcce.png';
import styles from '../css/Archives.module.css';
import SfwImage from '../../../components/AgeVerificationComponents/SfwImage';


class Arhive extends React.Component {
  constructor(...args) {
    super(...args);
    this.dayjs = dayjs;
    this.dayjs.extend(utc);
  }

  render() {
    const { arhive, typeOfListing, listingId, slug, searchFullText } = this.props;
    const imageLink = (arhive.clipView && arhive.clipView.thumbnailImageUrl) ? arhive.clipView.thumbnailImageUrl : arhive.image;
    const date = arhive?.publishedAt || arhive?.date;
    const title = arhive?.title || arhive?.name;
    const parsedSlug = parseSlug(arhive, typeOfListing, listingId, slug, searchFullText);
    const utcDate = this.dayjs(date).utc();

    return (
      <div className="col-md-3 col-sm-4 col-xs-12">
        <div className="thumbnail" title={title}>
          <Link className="lazy video" to={parsedSlug}>
            <SfwImage
              alt="Xlthumb placeholder"
              className="img-responsive video-thumbnail"
              sfwImage={arhive?.sfwAssetImage}
              nsfwImage={imageLink}
              style={{ opacity: 1 }}
            />
            <img
              alt="Play 54"
              className="play-icon"
              src={play}
            />
          </Link>
          <div className={styles.caption}>
            {typeOfListing === 'date' || typeOfListing === 'all' ? (
              <div className={styles.linkContainer}>
                <Link className={styles.title} to={parsedSlug}>
                  {title}
                </Link>
                {typeOfListing !== 'vintage' && (
                  <h6 className="text-muted">{utcDate.format('dddd LL')}</h6>
                )}
              </div>
            ) : (
              <div className={styles.linkContainer}>
                <Link className={styles.title} to={parsedSlug}>{title}</Link>
                {typeOfListing !== 'vintage' && (
                  <h6 className="text-muted">{utcDate.format('dddd LL')}</h6>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Arhive;
